// localImageLoader.js
export default function localImageLoader({ src, width, quality = 75 }) {
	return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${
		quality || 75
	}`;
}
